import API from './api';

export const listAllRequest = () =>
  API.get('/myComments')
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const listByLessonRequest = ({ courseId, lessonId }) =>
  API.get(`/course/${courseId}/lesson/${lessonId}/comments`)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const storeRequest = ({ courseId, lessonId, commentData }) =>
  API.post(`/course/${courseId}/lesson/${lessonId}/comment`, commentData)
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const updateRequest = ({ courseId, lessonId, commentId, commentData }) =>
  API.put(
    `/course/${courseId}/lesson/${lessonId}/comment/${commentId}`,
    commentData,
  )
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const removeRequest = ({ courseId, lessonId, commentId }) =>
  API.delete(`/course/${courseId}/lesson/${lessonId}/comment/${commentId}`)
    .then(res => res)
    .catch(err => {
      throw err;
    });
